import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

import profImg from "../../image/prof.JPG"

const IntroChief = () => {

   return (
      <IntroChiefStyles id="profile" >
         <h3>塾長プロフィール</h3>
         <div className="prof-box">
            <div className="img-wrap">
               <img src={profImg} alt=""/>
            </div>
            <div className="texts-wrap">
               <h4 className="name">石田 天心</h4>
               <p className="bg">
                  東進ハイスクールにて28年間勤務。<br/>
                  日本最大規模の主要拠点校舎責任者歴任。<br/> 
                  退職後この地にて天心塾を開校し、 今に至る。
               </p>
            </div>
         </div>
      </IntroChiefStyles>
   )
}

const IntroChiefStyles = styled.section`
   width: 100%;
   color: #FF3D01;
   .prof-box {
      width: 60%;
      margin: 30px auto;
      display: flex;
      justify-content: space-between;
      ${media.lessThan("960px")`
         width: 80%;
         flex-direction: column;
         align-items: center;
      `}
      .img-wrap {
         width: 200px;
         height: 200px;
         border-radius: 50%;
         border: 2px solid;
         overflow: hidden;
         ${media.lessThan("600px")`
            width: 140px;
            height: 140px;
         `}
         img {
            width: 100%;
         }
      }
      .texts-wrap {
         display: flex;
         flex-direction: column;
         justify-content: space-evenly;
         .name {
            font-size: 4rem;
            ${media.lessThan("960px")`
               text-align: center;
               margin-top: 20px;
               font-size: 3.2rem;
            `}
            ${media.lessThan("600px")`
               font-size: 3rem;
            `}
         }
         .bg {
            font-size: 2.2rem;
            line-height: 3.4rem;
            ${media.lessThan("960px")`
               margin-top: 20px;
               font-size: 1.8rem;
            `}
            ${media.lessThan("600px")`
               font-size: 1.5rem;
               line-height: 2.2rem;
            `}
         }
      }
   }
`

export default IntroChief